var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.cardComponent,{tag:"component",attrs:{"user":_vm.user,"isProfile":_vm.isProfile}})}
var staticRenderFns = []

export { render, staticRenderFns }